'use client';

import React, { useState, useEffect } from 'react';
import {Link} from '@heroui/link';
import { ArrowUturnLeftIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';
import { Select, SelectItem } from '@heroui/select';
import { Button } from '@/components/ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { User } from '@/components/Types';
import { useParams, useRouter } from 'next/navigation';
import { loadCurrentUser, updateLearningLanguage } from '@/store/actions/app';
import { setCurrentUser, setLocale } from '@/store/reducers/appSlice';
import { api } from '@/lib/api-requests';
import { Skeleton } from '@heroui/skeleton';
import { isBlank } from '@/lib/utils';
import { useUserLocale } from '@/hooks/useUserLocale';
import clsx from 'clsx';
import { addToast } from '@heroui/toast';
import ContentBlock from '@/components/ContentBlock';
import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import { motionDefaultPresence } from '@/lib/constants-ui';
import { HomeIcon } from '@heroicons/react/24/outline';

export default function ContentPage() {
  const { locale, t } = useUserLocale();
  
  const user = useSelector((state: any) => state.app.currentUser) as User;
  const isMobileScreen = useSelector((state: any) => state.app.isMobileScreen);
  const router = useRouter();
  const dispatch = useDispatch();

  const [readyToGoBack, setReadyToGoBack] = useState(false);

  const { id } = useParams();

  const handleGoBack = () => {
    router.back();
  }

  const handleGoHome = () => {
    router.push('/');
  }

  useEffect(() => {
    setTimeout(() => {
      setReadyToGoBack(true);
    }, 1000);
  }, []);

  return (
    <main className={`max-w-xl mx-auto min-h-screen px-0 sm:px-6 lg:px-8 ${isMobileScreen ? 'pt-12' : 'pt-0'} relative`}>
      <div className="max-w-lg mx-auto p-6">
        <ContentBlock className="text-gray-600" contentKey={id as string} language="english" format="html" />    
      </div>
          
      <AnimatePresence>
          {readyToGoBack && (
              <motion.div
                  key="submit-section"
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  variants={motionDefaultPresence}
                  className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 px-6 z-20"
              >
                <div className='flex items-center gap-2 justify-between max-w-md mx-auto'>
                  <Button onPress={handleGoBack} size='lg'>
                    <ArrowUturnLeftIcon className="size-4" />
                    {t.common.back}
                  </Button>
                  <Button onPress={handleGoBack} size='lg' variant='ghost'>
                    <HomeIcon className="size-4" />
                    {t.common.close}
                  </Button>
                </div>
              </motion.div>
          )}
      </AnimatePresence>
    </main>
  );
} 